import { Linked } from "@type-r/models";
import * as React from "react";
import { OrderModel } from "api";
import {
  asTimelessDate,
  asCurrency,
  AttachButton,
  Button,
  Flex,
  PageHeaderTile,
  PageTileField,
  PrimaryButton,
  Toolbar
} from "lqx-react";
import { OrderStateFlow, orderStatusColor } from "../common";
import { DialogType } from "./dialogs";

export const OrderHeader = ({
  order,
  $dialog
}: {
  order: OrderModel;
  $dialog: Linked<DialogType>;
}) => {
  const { displayFlags } = order;
  return (
    <PageHeaderTile
      color={orderStatusColor(order.status)}
      title={order.title}
      right={<OrderStateFlow order={order} />}
      toolbar={
        <Toolbar>
          <Flex grow />
          {/* <EditButton /> */}

          <AttachButton onClick={() => $dialog.set("upload")} />

          <OrderEditActions order={order} $dialog={$dialog} />
        </Toolbar>
      }
    >
      <PageTileField label="Status">{order.status}</PageTileField>
      <PageTileField label="PO Date">
        {asTimelessDate(order.po_details.po_date)}
      </PageTileField>
      <PageTileField label="PO #">{order.po_number}</PageTileField>
      <PageTileField label="SO #">{order.sales_order_id}</PageTileField>
      <PageTileField label="QUOTE #">{order.quote.id}</PageTileField>
      <PageTileField label="Total Price">
        {asCurrency(order.total_price)}
      </PageTileField>
      {displayFlags ? (
        <PageTileField label="Flags">{displayFlags}</PageTileField>
      ) : null}
    </PageHeaderTile>
  );
};

const OrderEditActions = ({
  order,
  $dialog
}: {
  order: OrderModel;
  $dialog: Linked<DialogType>;
}) => {
  const { status, isDistributorHold, isCancelled, hasPdfUploads } = order;
  return order.isSuperSupplier ? (
    <>
      {status === "PO Complete" ? (
        <Button onClick={() => $dialog.set("reset")}>Reset</Button>
      ) : null}

      {status === "Unvalidated" ||
      status === "PO Pending" ||
      status === "PO Complete" ? (
        <PrimaryButton
          disabled={order.disableValidatePOButton}
          onClick={() => $dialog.set("validate")}
        >
          Validate PO
        </PrimaryButton>
      ) : null}
    </>
  ) : order.isCustomerWrite ? (
    <>
      {status === "PO Complete" ? (
        <>
          <Button onClick={() => $dialog.set("hold")}>
            {isDistributorHold ? "Release Hold" : "Hold"}
          </Button>

          {!isCancelled ? (
            <Button onClick={() => $dialog.set("cancel")}>Cancel</Button>
          ) : null}
        </>
      ) : null}

      {status === "PO Pending" || status === "PO Complete" ? (
        <PrimaryButton
          disabled={!order.isValid()}
          onClick={() => $dialog.set("submit")}
        >
          Submit PO
        </PrimaryButton>
      ) : null}
    </>
  ) : null;
};
